import i18next from 'i18next';
import { BillPathsEnum } from 'modules/billsPage/routes';
import {
  getLeasingOfferPageUrl,
  LeasingOffersKeys,
} from '../../../../leasingOffersPage/components/helper';
import {
  ContractsTabKeys,
  getContractsPageUrl,
} from '../../../../contractsPage/components/helper';

export enum SearchItemCategory {
  CONTRACT = 'contract',
  BILL = 'bill',
  OFFER = 'offer',
}

export const getSearchItemCategoryLabel = (itemCategory: string) => {
  switch (itemCategory) {
    case SearchItemCategory.CONTRACT:
      return i18next.t('headerSearch.contractLabel');
    case SearchItemCategory.BILL:
      return i18next.t('headerSearch.billLabel');
    case SearchItemCategory.OFFER:
      return i18next.t('headerSearch.offerLabel');
    default:
      return itemCategory;
  }
};

export const getSearchItemLocation = (itemCategory: string) => {
  switch (itemCategory) {
    case SearchItemCategory.CONTRACT:
      return getContractsPageUrl(ContractsTabKeys.Active);
    case SearchItemCategory.BILL:
      return BillPathsEnum.bills;
    case SearchItemCategory.OFFER:
      return getLeasingOfferPageUrl(LeasingOffersKeys.Active);
    default:
      return '';
  }
};
